module.exports = __webpack_public_path__ + "img/Email.9d17ebc7.svg";